import React from 'react';
import { useTranslation } from 'react-i18next';
// import Flag from 'react-world-flags'; // Keep this commented for now
// import ReactCountryFlag from 'react-country-flag'; // Remove this import
import EnFlag from '../assets/flags/EN-flag.png'; // Import local EN flag
import HrFlag from '../assets/flags/HR-flag.png'; // Import local HR flag

const LanguageSwitcher = ({ onSwitch }) => {
    const { i18n } = useTranslation(); // Restore hook

    const handleLanguageChange = (lang) => { // Restore handler
        i18n.changeLanguage(lang);
        localStorage.setItem('selectedLanguage', lang);
        if (onSwitch) {
            onSwitch();
        }
    };

    // Restore styles - Adjust size within className now
    const flagBaseStyle = "cursor-pointer transition-all duration-300 ease-in-out block w-6 h-auto"; // Use w-6 (24px) and h-auto
    const flagSelectedStyle = "scale-125 -translate-y-0.5 opacity-100"; // Adjusted translate-y slightly
    const flagUnselectedStyle = "scale-100 translate-y-0 opacity-60 hover:opacity-100";
    // Remove flagIconStyle as it's not needed for img tags

    return (
        <div className="flex items-center space-x-3">
            {/* Div for English flag, using local image */}
            <div
                onClick={() => handleLanguageChange('en')}
                title="English"
                className={`${i18n.language === 'en' || i18n.language.startsWith('en-') ? flagSelectedStyle : flagUnselectedStyle}`}
            >
                <img
                    src={EnFlag}
                    alt="English"
                    className={`${flagBaseStyle}`} // Apply base styles directly
                />
            </div>
            {/* Div for Croatian flag, using local image */}
            <div
                onClick={() => handleLanguageChange('hr')}
                title="Hrvatski"
                className={`${i18n.language === 'hr' ? flagSelectedStyle : flagUnselectedStyle}`}
            >
                <img
                    src={HrFlag}
                    alt="Hrvatski"
                    className={`${flagBaseStyle}`} // Apply base styles directly
                />
            </div>
        </div>
    );
};

export default LanguageSwitcher; 